import { BrowserRouter, Navigate, Route, Routes, } from "react-router-dom";
import { useEffect, useState } from "react";
import { UserContextProvider } from './context'
import Home from "./screens/Home";
import Settings from "./screens/Settings";
import SecurityQAs from "screens/SecurityQAs";
import PaymentHistory from "./screens/PaymentHistory";
import PolicyIdCards from "./screens/PolicyIdCards";

import NewAddress from "./screens/AddressChange/NewAddress";
import Household from "./screens/AddressChange/Household";
import Additional from "./screens/AddressChange/Additional";
import DriverAssignment from "./screens/AddressChange/DriverAssignment";
import Summary from "./screens/AddressChange/Summary";
import Confirmation from "./screens/AddressChange/Confirmation";

// New Household Pages
import UpdateHousehold from "./screens/HouseholdChange/UpdateHousehold";
import UpdateHouseholdDriverAssignment from "screens/HouseholdChange/UpdateHouseholdDriverAssignment";
import UpdateHouseholdAdditional from "screens/HouseholdChange/UpdateHouseholdAdditional";
import UpdateHouseholdSummary from "screens/HouseholdChange/UpdateHouseholdSummary";
import UpdateHouseholdConfirmation from "screens/HouseholdChange/UpdateHouseholdConfirmation";

// Old Vehicle Pages
import UpdateVehicles from "./screens/UpdateVehicles_Old/UpdateVehicles";
import UpdateDriverAssignment from "./screens/UpdateVehicles_Old/UpdateDriverAssignment";
import UpdateVehicleSummary from "./screens/UpdateVehicles_Old/UpdateVehicleSummary";
import UpdateVehicleConfirmation from "./screens/UpdateVehicles_Old/UpdateVehicleConfirmation";

// New Vehicle pages
import Vehicles from "./screens/VehicleChange/Vehicles";
import VehiclesDriverAssignment from "./screens/VehicleChange/VehiclesDriverAssignment"
import VehiclesSummary from "./screens/VehicleChange/VehiclesSummary"
import VehiclesConfirmation from "./screens/VehicleChange/VehiclesConfirmation"

// Straight Through Endorsements 
//////////////// (Add Vehicle) ////////////////
import AddVehicle from "screens/StraightThroughVehicle/AddVehicle/AddVehicle";
import ConfirmVehicle from "screens/StraightThroughVehicle/AddVehicle/ConfirmVehicle";
import EndorsementSummary from "screens/StraightThroughVehicle/AddVehicle/EndorsementSummary";
import EndorsementBlock from "screens/StraightThroughVehicle/AddVehicle/EndorsementBlock";
import EndorsementFail from "screens/StraightThroughVehicle/AddVehicle/EndorsementFail";

//////////////// (Remove Vehicle) ////////////////
import RemoveVehicle from "screens/StraightThroughVehicle/RemoveVehicle/RemoveVehicle";
import ConfirmRemoveVehicle from "screens/StraightThroughVehicle/RemoveVehicle/ConfirmRemoveVehicle";
import RemoveVehicleEndorsementSummary from "screens/StraightThroughVehicle/RemoveVehicle/RemoveVehicleEndorsementSummary";
import RemoveVehicleEndorsementBlock from "screens/StraightThroughVehicle/RemoveVehicle/RemoveVehicleEndorsementBlock";
import RemoveVehicleEndorsementFail from "screens/StraightThroughVehicle/RemoveVehicle/RemoveVehicleEndorsementFail";

//////////////// (Replace Vehicle) ////////////////
import ReplaceVehicle from "screens/StraightThroughVehicle/ReplaceVehicle/ReplaceVehicle";
import ConfirmReplaceVehicle from "screens/StraightThroughVehicle/ReplaceVehicle/ConfirmReplaceVehicle";
import ReplaceVehicleEndorsementSummary from "screens/StraightThroughVehicle/ReplaceVehicle/ReplaceVehicleEndorsementSummary";
import ReplaceVehicleEndorsementBlock from "screens/StraightThroughVehicle/ReplaceVehicle/ReplaceVehicleEndorsementBlock";
import ReplaceVehicleEndorsementFail from "screens/StraightThroughVehicle/ReplaceVehicle/ReplaceVehicleEndorsementFail";

//////////////// (Address Change) ////////////////
import ChangeAddress from "screens/StraightThroughAddress/1_ChangeAddress";
import ChangeAddress_Household from "screens/StraightThroughAddress/2_ChangeAddress_Household";
import ChangeAddress_DriverAssignment from "screens/StraightThroughAddress/3_ChangeAddress_DriverAssignment";
import ChangeAddress_Confirm from "screens/StraightThroughAddress/4_ChangeAddress_Confirm";

//////////////// (Household Change) ////////////////
import HouseholdStraightThrough from "screens/StraightThroughDriverHHM/Household";
import HouseholdConfirm from "screens/StraightThroughDriverHHM/HouseholdConfirm";
import HouseholdDriverAssignment from "screens/StraightThroughDriverHHM/HouseholdDriverAssignment";
import HouseholdDriverFail from "screens/StraightThroughDriverHHM/HouseholdFail";
import HouseholdSummary from "screens/StraightThroughDriverHHM/HouseholdSummary";
import HouseholdBlock from "screens/StraightThroughDriverHHM/HouseholdBlock";


// Renewal Questionnaire
import RQ_Residence from "./screens/RenewalQuestionnaire/RQ_Residence";
import RQ_DriverOHM from "./screens/RenewalQuestionnaire/RQ_DriverOHM";
import RQ_AdditionalInfo from "./screens/RenewalQuestionnaire/RQ_AdditionalInfo";
import RQ_Vehicles from "./screens/RenewalQuestionnaire/RQ_Vehicles";
import RQ_Sign from "./screens/RenewalQuestionnaire/RQ_Sign";

import Login from "./screens/Login";
import Layout from "./screens/Layout";
import NoPage from "./screens/NoPage";
import Landing from "./components/Landing";
import LoadPolicyChangeInfo from "./components/LoadPolicyChangeInfo";
import OneInc from "./screens/OneInc";
// import AutoPay from "./components/OneInc/OneIncAutoPay";
import RegisterEbilling from "./screens/RegisterEbilling";
import RegisterEbillingFinish from "./screens/RegisterEbillingFinish";
import DocumentsVault from "./screens/DocumentsVault";
import QuickService from "./screens/QuickService/QuickService";
import QSIDCards from "./screens/QuickService/QSIDCards";
import QSBillingInfo from "./screens/QuickService/QSBillingInfo";
import { storageData } from "./services/Services";
import PolicyDocuments from "./screens/PolicyDocuments";
import ExtLogin from "./screens/ExtLogin";
import Maintenance from "screens/Maintenance";
import { getDomainOneInc, getSiteEnv, getTestingEnvToken, productionLogger } from "./services/Utils";
import Cookies from 'js-cookie';
import { GetEnvironmentSettings, updateOneIncTokens } from "services/Api";
import ReportClaim from "screens/ReportClaim";
import { ServerDateProvider } from "services/ServerDateContext";
// import "./css/App.css";

function App() {
  const [storedData, setStoredDataOrig] = useState({});
  const setStoredData = (newStoredData) => {
    if (JSON.stringify(storedData) !== JSON.stringify(newStoredData)) {
      setStoredDataOrig(newStoredData)
    }
  }
  const [userData, setUserData] = useState(storageData.getItem("userData") !== null ? JSON.parse(storageData.getItem("userData")) : { complete: false })
  const [paymentData, setPaymentData] = useState(storageData.getItem("paymentData") !== null ? JSON.parse(storageData.getItem("paymentData")) : { complete: false })

  useEffect(() => {
    if (userData?.complete) {
      storageData.setItem("userData", JSON.stringify(userData));
    }
  }, [userData]);

  useEffect(() => {
    if (Cookies.get('CTLE', { domain: '.cure.com' }) != getTestingEnvToken() && getSiteEnv(GetEnvironmentSettings) != 'prod') {
      window.location = "https://www.cure.com";
    }
    productionLogger()
  }, [])

  const routesList = [
    { path: "settings", element: <Settings user={{ userData, setUserData }} /> },
    { path: "security-qas", element: <SecurityQAs user={{ userData, setUserData }} /> },
    { path: "payment-history", element: <PaymentHistory user={{ userData, setUserData }} payment={{ paymentData, setPaymentData }} /> },
    { path: "oneinc", element: <OneInc user={{ userData, setUserData }} payment={{ paymentData, setPaymentData }} /> },
    { path: "register-ebilling", element: <RegisterEbilling user={{ userData, setUserData }} payment={{ paymentData, setPaymentData }} /> },
    { path: "register-ebilling-finish", element: <RegisterEbillingFinish user={{ userData, setUserData }} /> },
    { path: "documents-vault", element: <DocumentsVault user={{ userData, setUserData }} payment={{ paymentData, setPaymentData }} /> },
    { path: "report-claim", element: <ReportClaim storedData={storedData} setStoredData={setStoredData} user={{ userData, setUserData }}/> },
    { path: "policy-id-cards", element: <PolicyIdCards user={{ userData, setUserData }} /> },
    { path: "quick-service/BillingInfo", element: <QSBillingInfo user={{ userData, setUserData }} /> },
    { path: "quick-service/IDCards", element: <QSIDCards user={{ userData, setUserData }} /> },
    {
      path: "change-address/landing", element: <LoadPolicyChangeInfo storedData={{ ...storedData }} setStoredData={setStoredData} user={{ userData, setUserData }} />
    },
    {
      path: "change-address/new-address", element: <NewAddress storedData={{ ...storedData }} setStoredData={setStoredData} user={{ userData, setUserData }} />
    },
    {
      path: "change-address/household", element: <Household storedData={{ ...storedData }} setStoredData={setStoredData} user={{ userData, setUserData }} />
    },
    {
      path: "change-address/additional", element: <Additional storedData={{ ...storedData }} setStoredData={setStoredData} user={{ userData, setUserData }} />
    },
    {
      path: "change-address/driver-assignment", element: <DriverAssignment storedData={{ ...storedData }} setStoredData={setStoredData} user={{ userData, setUserData }} />
    },
    {
      path: "change-address/summary", element: <Summary storedData={{ ...storedData }} setStoredData={setStoredData} user={{ userData, setUserData }} />
    },
    {
      path: "change-address/confirmation", element: <Confirmation storedData={{ ...storedData }} setStoredData={setStoredData} user={{ userData, setUserData }} />
    },
    { path: "404", element: <NoPage /> },
    {
      path: "update-drivers/landing", element: <LoadPolicyChangeInfo storedData={{ ...storedData }} setStoredData={setStoredData} user={{ userData, setUserData }} />
    },
    {
      path: "update-drivers/update-household", element: <UpdateHousehold storedData={{ ...storedData }} setStoredData={setStoredData} user={{ userData, setUserData }} />
    },
    {
      path: "update-drivers/driver-assignment", element: <UpdateHouseholdDriverAssignment storedData={{ ...storedData }} setStoredData={setStoredData} user={{ userData, setUserData }} />
    },
    {
      path: "update-drivers/additional", element: <UpdateHouseholdAdditional storedData={{ ...storedData }} setStoredData={setStoredData} user={{ userData, setUserData }} />
    },
    {
      path: "update-drivers/summary", element: <UpdateHouseholdSummary storedData={{ ...storedData }} setStoredData={setStoredData} user={{ userData, setUserData }} />
    },
    {
      path: "update-drivers/confirmation", element: <UpdateHouseholdConfirmation storedData={{ ...storedData }} setStoredData={setStoredData} user={{ userData, setUserData }} />
    },
    {
      path: "update-vehicles/landing", element: <LoadPolicyChangeInfo storedData={{ ...storedData }} setStoredData={setStoredData} user={{ userData, setUserData }} />
    },
    {
      path: "update-vehicles/vehicles", element: <Vehicles storedData={{ ...storedData }} setStoredData={setStoredData} user={{ userData, setUserData }} />
    },
    {
      path: "update-vehicles/driver-assignment", element: <VehiclesDriverAssignment storedData={{ ...storedData }} setStoredData={setStoredData} user={{ userData, setUserData }} />
    },
    {
      path: "update-vehicles/summary", element: <VehiclesSummary storedData={{ ...storedData }} setStoredData={setStoredData} user={{ userData, setUserData }} />
    },
    {
      path: "update-vehicles/confirmation", element: <VehiclesConfirmation storedData={{ ...storedData }} setStoredData={setStoredData} user={{ userData, setUserData }} />
    },
    {
      path: "renewalQuestionnaire/landing", element: <LoadPolicyChangeInfo storedData={{ ...storedData }} setStoredData={setStoredData} user={{ userData, setUserData }} />
    },
    {
      path: "renewalQuestionnaire/residence", element: <RQ_Residence storedData={{ ...storedData }} setStoredData={setStoredData} user={{ userData, setUserData }} />
    },
    {
      path: "renewalQuestionnaire/driverohm", element: <RQ_DriverOHM storedData={{ ...storedData }} setStoredData={setStoredData} user={{ userData, setUserData }} />
    },
    {
      path: "renewalQuestionnaire/additionalInfo", element: <RQ_AdditionalInfo storedData={{ ...storedData }} setStoredData={setStoredData} user={{ userData, setUserData }} />
    },
    {
      path: "renewalQuestionnaire/vehicle", element: <RQ_Vehicles storedData={{ ...storedData }} setStoredData={setStoredData} user={{ userData, setUserData }} />
    },
    {
      path: "renewalQuestionnaire/sign", element: <RQ_Sign storedData={{ ...storedData }} setStoredData={setStoredData} user={{ userData, setUserData }} />
    },
    {
      path: "policy-documents", element: <PolicyDocuments user={{ userData, setUserData }} />
    },
    {
      path: "maintenance", element: <Maintenance user={{ userData, setUserData }} />
    },
    {
      path: "endorsement/add-landing", element: <LoadPolicyChangeInfo storedData={{ ...storedData }} setStoredData={setStoredData} user={{ userData, setUserData }} />
    },
    {
      path: "endorsement/add-vehicle", element: <AddVehicle user={{ userData, setUserData }} />
    },
    {
      path: "endorsement/add-vehicle-confirm", element: <ConfirmVehicle user={{ userData, setUserData }} />
    },
    {
      path: "endorsement/summary", element: <EndorsementSummary user={{ userData, setUserData }} />
    },
    {
      path: "endorsement/thank-you", element: <EndorsementFail user={{ userData, setUserData }} />
    },
    {
      path: "endorsement/block", element: <EndorsementBlock user={{ userData, setUserData }} />
    },
    {
      path: "endorsement/remove-landing", element: <LoadPolicyChangeInfo storedData={{ ...storedData }} setStoredData={setStoredData} user={{ userData, setUserData }} />
    },
    {
      path: "endorsement/remove-vehicle", element: <RemoveVehicle user={{ userData, setUserData }} />
    },
    {
      path: "endorsement/remove-vehicle-confirm", element: <ConfirmRemoveVehicle user={{ userData, setUserData }} />
    },
    {
      path: "endorsement/remove-vehicle-summary", element: <RemoveVehicleEndorsementSummary user={{ userData, setUserData }} />
    },
    {
      path: "endorsement/remove-vehicle-thank-you", element: <RemoveVehicleEndorsementFail user={{ userData, setUserData }} />
    },
    {
      path: "endorsement/remove-vehicle-block", element: <RemoveVehicleEndorsementBlock user={{ userData, setUserData }} />
    },
    {
      path: "endorsement/replace-landing", element: <LoadPolicyChangeInfo storedData={{ ...storedData }} setStoredData={setStoredData} user={{ userData, setUserData }} />
    },
    {
      path: "endorsement/replace-vehicle", element: <ReplaceVehicle user={{ userData, setUserData }} />
    },
    {
      path: "endorsement/replace-vehicle-confirm", element: <ConfirmReplaceVehicle user={{ userData, setUserData }} />
    },
    {
      path: "endorsement/replace-vehicle-summary", element: <ReplaceVehicleEndorsementSummary user={{ userData, setUserData }} />
    },
    {
      path: "endorsement/replace-vehicle-thank-you", element: <ReplaceVehicleEndorsementFail user={{ userData, setUserData }} />
    },
    {
      path: "endorsement/replace-vehicle-block", element: <ReplaceVehicleEndorsementBlock user={{ userData, setUserData }} />
    },
    {
      path: "endorsement/change-address-landing", element: <LoadPolicyChangeInfo storedData={{ ...storedData }} setStoredData={setStoredData} user={{ userData, setUserData }} />
    },
    {
      path: "endorsement/new-address", element: <ChangeAddress user={{ userData, setUserData }} />
    },
    {
      path: "endorsement/address/household", element: <ChangeAddress_Household user={{ userData, setUserData }} />
    },
    {
      path: "endorsement/address/driver-assignment", element: <ChangeAddress_DriverAssignment user={{ userData, setUserData }} />
    },
    {
      path: "endorsement/address/confirm", element: <ChangeAddress_Confirm user={{ userData, setUserData }} />
    },
    {
      path: "endorsement/household-landing", element: <LoadPolicyChangeInfo storedData={{ ...storedData }} setStoredData={setStoredData} user={{ userData, setUserData }} />
    },
    {
      path: "endorsement/household", element: <HouseholdStraightThrough user={{ userData, setUserData }} />
    },
    {
      path: "endorsement/household/driver-assignment", element: <HouseholdDriverAssignment user={{ userData, setUserData }} />
    },
    {
      path: "endorsement/household/confirm", element: <HouseholdConfirm user={{ userData, setUserData }} isHousehold={true}/>
    },
    {
      path: "endorsement/household/household-summary", element: <HouseholdSummary user={{ userData, setUserData }} isHousehold={true}/>
    },
    {
      path: "endorsement/household/household-fail", element: <HouseholdDriverFail user={{ userData, setUserData }} isHousehold={true}/>
    },
    {
      path: "endorsement/household/household-block", element: <HouseholdBlock user={{ userData, setUserData }} isHousehold={true}/>
    },
    {
      path: "endorsement/address/address-summary", element: <HouseholdSummary user={{ userData, setUserData }} />
    },
    {
      path: "endorsement/address/address-fail", element: <HouseholdDriverFail user={{ userData, setUserData }} />
    },
    {
      path: "endorsement/address/address-block", element: <HouseholdBlock user={{ userData, setUserData }} />
    },
  ].map((value, index) => {
    return (
      <Route key={index} path={value.path} element={value.element} />
    )
  })
  const OneIncRedirect = () => {
    window.location.href = `https://${getDomainOneInc()}/`;
  };
  const AutoPay = ({ user }) => {
    const {
      userData: { policyNumber, env, zip },
    } = user;
    const updateOneIncTokens_response = updateOneIncTokens(policyNumber, zip, env, ['autopay'], 'MyAccount').then((e) => {
      const autopayToken = e.Tokens.find((x) => x.Type === 'autopay').Value;
      if (autopayToken !== '') {
        window.location.replace(`https://${getDomainOneInc()}/?Token=${autopayToken}`);
      }
    });
  };

  return (
    <ServerDateProvider>
    <BrowserRouter>
      <UserContextProvider>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Login user={{ userData, setUserData }} />} />
            {
              storageData.getItem("userData") &&
              <Route path="*" element={<Navigate to='/home' replace />} />
            }
            <Route path="home" element={
              <Home user={{ userData, setUserData }} payment={{ paymentData, setPaymentData }} />
            } />
            <Route path="quick-service" element={<QuickService user={{ userData, setUserData }} />} />
            <Route path="ext-login" element={<ExtLogin user={{ userData, setUserData }} />} />
            <Route path="oneinc.aspx" element={<OneIncRedirect />} />
            <Route path="enroll-autopay" element={<AutoPay user={{ userData, setUserData }}/>} />
            {
              routesList
            }
          </Route >
        </Routes>
      </UserContextProvider>
    </BrowserRouter >
    </ServerDateProvider>
  );
}

export default App;